exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".skill_detail-dialog.yxtf-dialog--medium .yxtf-dialog__body{padding-right:0;padding-left:0}\n", ""]);

